<template>
  <el-container class="member_card" >
    
    <el-header class="header-style">
    <el-divider content-position="left">会员卡列表</el-divider>
    <el-row>
      <el-col :span="24">
        <el-select
          style="width:270px;"
          v-model="searchArr.card_no"
          filterable
          remote
          placeholder="请输入会员卡号"
          size="mini"
          clearable
          :remote-method="searchRemoteCardNoMethod"
          :loading="searchLoading"
          @change="handleSearchCardNoChange"
        >
          <el-option
            v-for="searchCardNo in searchCardNoList"
            :key="searchCardNo.id"
            :label="searchCardNo.card_no"
            :value="searchCardNo.card_no"
          >
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="450">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="是否开启" prop="is_open">
              <el-select v-model="searchArr.is_open" placeholder="是否开启" clearable size="mini">
                <el-option label="未启用" :value="0"></el-option>
                <el-option label="已启用" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否激活" prop="status">
              <el-select v-model="searchArr.status" placeholder="是否激活" clearable size="mini">
                <el-option label="未激活" :value="0"></el-option>
                <el-option label="已激活" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button @click="resetForm('searchForm')" size="mini"
                >重置</el-button>
              <el-button
                type="primary"
                @click="submitForm('searchForm')"
                size="mini"
                >查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
        <el-button style="float: right;" type="primary" size="mini" @click="handleCreateBatch">批量生成</el-button>
        <el-button style="float: right;margin-right: .2rem;" type="primary" size="mini" @click="handleAddAllot">批量启用</el-button>
        <el-button style="float: right;" type="primary" size="mini" @click="handleBatchExport">批量导出</el-button>
      </el-col>
      <!-- <el-upload style="float: right" :action="actionHost + '/api/admin/member_card/import'" :headers="uploadHeader"
        :show-file-list="false" :on-success="handleImport">
        <el-button type="primary" size="mini">导入</el-button>
      </el-upload> -->
    </el-row>
  </el-header>

  <el-main class="main-style">
    <el-table
    height="calc(100vh - 276px)"
      :data="memberCardList"
      size="medium"
      border
      style="width: 100%;"
      v-cloak
      @selection-change="handleSelectionChange"
    >
    <el-table-column type="selection" width="55" fixed></el-table-column>
    <el-table-column label="会员卡号" width="350">
        <template slot-scope="scope">
          <div v-if="scope.row.card_no" style="display:inline-block">
              <span class="count-style">{{ scope.row.card_no }}</span>
            <el-tooltip class="item" effect="dark" content="复制" placement="top">
              <i class="el-icon-document-copy" style="cursor:pointer;position: relative;top: -.12rem;" @click="copyCardNo(scope.row.card_no)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="卡类型" width="">
        <template slot-scope="scope">
          <div v-if="scope.row.card_type">
              <span class="count-style">{{ scope.row.card_type }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否启用" width="80">
        <template slot-scope="scope">
          <div>
              <span class="count-style">{{ scope.row.is_open }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="激活状态" width="80">
        <template slot-scope="scope">
          <div>
              <span class="count-style">{{ scope.row.status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最晚激活期限" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.motivate_deadline">
              <!-- <span class="count-style">{{ scope.row.motivate_deadline }}</span> -->
              <date-formatter :date-value="scope.row.motivate_deadline"></date-formatter>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="激活人手机号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.bind_user_mobile">
              <span class="count-style">{{ scope.row.bind_user_mobile }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="激活时间" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.motivate_time">
              <span class="count-style">{{ scope.row.motivate_time }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="会员卡使用到期时间" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.use_deadline">
              <span class="count-style">{{ scope.row.use_deadline }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="">
        <template slot-scope="scope">
          <div v-if="scope.row.created_at">
              <span class="count-style">{{ scope.row.created_at }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button :type="scope.row.status === 1 ? 'success' : 'info'"
              :icon="scope.row.status === 1 ? 'el-icon-check' : 'el-icon-edit-outline'" size="mini" circle
              @click="handleEditCardData(scope.$index, scope.row)" :disabled="scope.row.status === '已激活'"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="赠送会员" placement="top">
            <el-button :type="scope.row.status === 1 ? 'success' : 'info'" size="mini" :icon="scope.row.status === 1 ? 'el-icon-edit-outline' : 'el-icon-share'" :disabled="scope.row.status === '已激活'" circle
              @click="sendVipCard(scope.$index, scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </el-main>

  <el-footer class="footer-style">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </el-footer>

    <el-drawer
      title="编辑"
      :visible.sync="editDateDrawer"
      direction="rtl"
      :before-close="handleUpBeforeClose"
      size="35%">
      <div style="padding: 0 .2rem 0 .4rem">
      <el-form>
        <el-form-item label="激活截止日期">
          <el-date-picker
            v-model="saveData.motivate_deadline"
            type="date"
            size="mini"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="pickerDataChange"
            placeholder="选择激活截止日期">
          </el-date-picker>
        </el-form-item>
        <div class="addCon" style="margin-right: .15rem">
          <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
        </div>
      </el-form>
      </div>
    </el-drawer>
    <el-drawer title="赠送会员卡" :visible.sync="openSendVipCardDrawer" direction="rtl" :before-close="handleUpBeforeClose"
      size="35%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form>
          <el-form-item label="会员手机号">
            <el-input v-model="saveData.phone" placeholder="请输入会员手机号" type="text" size="mini"></el-input>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitSendVipCard">保存</el-button>
        </el-row>
      </div>
    </el-drawer>
    <!-- 批量生成会员卡号 -->
    <el-drawer title="批量生成会员卡" :visible.sync="batchCreateCardDrawer" direction="rtl" :before-close="handleUpBeforeClose"
      size="35%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form>
          <el-form-item label="卡类型">
            <el-select
              size="mini"
              v-model="batchCreateForm.card_type"
              clearable
              placeholder="请选择生成的卡类型"
            >
            <el-option :value="1" label="年VIP"></el-option>
            <el-option :value="2" label="月VIP"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡数量">
            <el-input v-model="batchCreateForm.card_nums" min="1" max="2000" placeholder="请选择生成的卡数量，" type="number" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="卡号长度">
            <el-select
              size="mini"
              v-model="batchCreateForm.card_length"
              clearable
              placeholder="请选择生成的卡号长度"
            >
            <el-option :value="18" label="十八位"></el-option>
            <el-option :value="21" label="二十一位"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用">
            否
            <el-switch
              v-model="batchCreateForm.is_open"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            是
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitBatchCreateCard">保存</el-button>
        </el-row>
      </div>
    </el-drawer>
    <!-- 批量导出 -->
    <el-drawer title="批量导出会员卡" :visible.sync="batchExportCardDrawer" direction="rtl" :before-close="handleUpBeforeClose"
      size="35%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form>
          <el-form-item label="卡类型">
            <el-select
              size="mini"
              v-model="batchExportForm.card_type"
              clearable
              placeholder="请选择卡类型"
            >
            <el-option :value="1" label="年VIP"></el-option>
            <el-option :value="2" label="月VIP"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡数量">
            <el-input v-model="batchExportForm.card_nums" min="1" max="2000" placeholder="请输入导出的卡数量，" type="number" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            否
            <el-switch
              v-model="batchExportForm.is_open"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            是
          </el-form-item>
          <el-form-item label="是否激活">
            否
            <el-switch
              v-model="batchExportForm.status"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            是
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitBatchExportCard">导出</el-button>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'MemberCard',
  components: {DateFormatter},
  data () {
    return {
      // 批量导出卡数据
      batchExportForm: {
        card_type: '',
        card_nums: 1,
        status: false,
        is_open: false
      },
      // 批量生成卡数据
      batchCreateForm: {
        card_type: '',
        card_nums: 1,
        card_length: '',
        is_open: false
      },
      // 搜索参数
      searchArr: {
        card_no: '',
        is_open: '',
        status: ''
      },
      pageNodes: [],
      // 搜索加载动效
      searchLoading: false,
      // 更多筛选显示控制
      visible: false,
      // 表格渲染数据
      memberCardList: [],
      // 搜索结果数据
      searchCardNoList: [],
      // 分页数据
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30 // 每页显示条数
      },
      // 文件导入配置
      uploadHeader: { Authorization: localStorage.token },
      // 时间筛选
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: picker => {
              picker.$emit('pick', [new Date(), new Date()])
            }
          },
          {
            text: '昨天',
            onClick: picker => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [date, date])
            }
          },
          {
            text: '本周',
            onClick: picker => {
              picker.$emit('pick', [this.thisWeek()[0], this.thisWeek()[1]])
            }
          },
          {
            text: '上周',
            onClick: picker => {
              picker.$emit('pick', [this.LastWeek()[0], this.LastWeek()[1]])
            }
          },
          {
            text: '本月',
            onClick: picker => {
              picker.$emit('pick', [this.thisMonth()[0], this.thisMonth()[1]])
            }
          },
          {
            text: '上个月',
            onClick: picker => {
              picker.$emit('pick', [this.LastMonth()[0], this.LastMonth()[1]])
            }
          }
        ]
      },
      // 编辑最晚激活时间显示
      editDateDrawer: false,
      // 编辑显示
      saveData: {
        motivate_deadline: '',
        card_no: '',
        phone: ''
      },
      // 多选
      multipleSelection: [],
      batchCardData: {
        ids: [],
        is_open: []
      },
      // 赠送会员面板
      openSendVipCardDrawer: false,
      // 批量生成卡号
      batchCreateCardDrawer: false,
      // 批量导出卡号
      batchExportCardDrawer: false
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getMemberCardList () {
      this.$axios
        .get(
          '/api/admin/member_card/index?page=' +
            this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.memberCardList = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
          }
        })
    },
    handleSave () {
      if (!this.saveData.motivate_deadline) {
        this.$message.error('请选择要设置的截止日期！')
        return
      }
      this.$axios.post('/api/admin/member_card/store', this.saveData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getMemberCardList()
            this.editDateDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 批量开启
    handleAddAllot () {
      if (this.multipleSelection.length) {
        this.$confirm('此操作将批量启用选中的卡片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 点击确定的操作(调用接口)
          for (var a = 0; a < this.multipleSelection.length; a++) {
            this.batchCardData.ids[a] = this.multipleSelection[a].id
            this.batchCardData.is_open[a] = this.multipleSelection[a].is_open
          }
          this.$axios.post('/api/admin/member_card/batchOpen', this.batchCardData)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.getMemberCardList()
              } else {
                this.$message.error(data.msg)
              }
            })
        }).catch(() => {
          // 点击取消的提示
          this.$message.error('已取消！') // 使用i18n国际化表示的“已取消删除”
        })
      } else {
        this.$message.error('请先选择要批量启用的卡片！')
      }
    },
    // 批量生成一批卡片
    handleCreateBatch () {
      this.batchCreateCardDrawer = true
    },
    // 批量导出一批卡号
    handleBatchExport () {
      this.batchExportCardDrawer = true
    },
    submitBatchExportCard () {
      if (!this.batchExportForm.card_type) {
        this.$message.error('请选择卡类型！')
        return
      }
      if (this.batchExportForm.card_nums < 1 || this.batchCreateForm.card_nums > 2000) {
        this.$message.error('卡数量必须介于1-2000之间！')
        return
      }
      this.$axios.post('/api/admin/member_card/batch_export', this.batchExportForm, { responseType: 'blob' })
        .then((res) => {
          const { data } = res
          if (data.status === 205) {
            this.$message.error(data.msg)
            return
          }
          let blob = new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          let objectUrl = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.download = '会员卡号导出.xlsx'
          link.click()
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl)
          }, 100)
        })
    },
    submitBatchCreateCard () {
      if (!this.batchCreateForm.card_type) {
        this.$message.error('请选择卡类型！')
        return
      }
      if (this.batchCreateForm.card_nums < 1 || this.batchCreateForm.card_nums > 2000) {
        this.$message.error('卡数量必须介于1-2000之间！')
        return
      }
      if (!this.batchCreateForm.card_length) {
        this.$message.error('请选择卡号长度！')
        return
      }
      this.$axios.post('/api/admin/member_card/batch_create', this.batchCreateForm)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getMemberCardList()
            this.editDateDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 编辑未激活的会员卡
    handleEditCardData (index, row) {
      // 编辑最晚激活时间
      this.editDateDrawer = true
      this.saveData.card_no = row.card_no
      this.saveData.motivate_deadline = row.motivate_deadline
    },
    // 选择日期
    pickerDataChange (val) {
      if (!val) {
        this.saveData.motivate_deadline = ''
      } else {
        this.saveData.motivate_deadline = val
      }
    },
    // 赠送会员
    sendVipCard (index, row) {
      this.openSendVipCardDrawer = true
      this.saveData.card_no = row.card_no
    },
    submitSendVipCard () {
      if (!this.saveData.phone) {
        this.$message.error('请输入要赠送的会员手机号！')
        return
      }
      this.$axios.post('/api/admin/member_card/sendVipCard', this.saveData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getMemberCardList()
            this.editDateDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 关闭编辑层
    handleUpBeforeClose (done) {
      this.clearUpdata()
      done()
    },
    clearUpdata () {
      this.saveData.motivate_deadline = ''
      this.saveData.card_no = ''
      this.saveData.phone = ''
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getMemberCardList()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getMemberCardList()
    },
    searchRemoteCardNoMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchSingleCardNo(query)
        }, 200)
      } else {
        this.searchCardNoList = []
      }
    },
    searchSingleCardNo (query) {
      this.$axios.get('/api/admin/member_card/searchSingleCardNo?card_no=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCardNoList = data.data.searchSingleCardNo
        }
      })
    },
    handleSearchCardNoChange () {
      this.pageOption.currentPage = 1
      this.getMemberCardList()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getMemberCardList()
    },
    submitForm (val) {
      this.pageOption.currentPage = 1
      this.getMemberCardList()
    },
    handleImport (res) {
      if (res.code === 0) {
        this.$message.success(res.msg)
      }
    },
    pickerSuccessTimeDateChange (val) {
      if (!val) {
        this.searchArr.transfer_start_time = []
        this.searchArr.transfer_end_time = []
      } else {
        this.searchArr.transfer_start_time = val[0]
        this.searchArr.transfer_end_time = val[1]
      }
    },
    // 复制卡号
    copyCardNo (data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    LastWeek () {
      const end = new Date()
      const start = new Date()
      const lastWeek = new Date().getDay() // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)) // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek)
      return [start, end]
    },
    thisWeek () {
      var Nowdate = new Date()
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000)

      var M = Number(WeekFirstDay.getMonth()) + 1
      var start =
        WeekFirstDay.getFullYear() + '-' + M + '-' + WeekFirstDay.getDate()

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000)
      var Mon = Number(WeekLastDay.getMonth()) + 1
      var end =
        WeekLastDay.getFullYear() + '-' + Mon + '-' + WeekLastDay.getDate()

      return [start, end]
    },
    thisMonth () {
      const end = new Date()
      const start = new Date()
      // 方法1
      const endDay = new Date().getDate() - 1 // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay)
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end]
    },
    LastMonth () {
      const end = new Date()
      const start = new Date()
      const year = new Date().getFullYear() // 获取年份
      let month = new Date().getMonth() // 获取月份
      month = month === 0 ? 1 : month // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28 // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] // 罗列12个月的天数
      start.setDate(1 - days[month - 1]) // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1) // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end]
    }
  },
  mounted () {
    this.getMemberCardList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.member_card >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.member_card {
  marginLeft();
  max-height: 100vh;
  .header-style {
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    padding: 0px !important;
    // overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/member_card/MemberCard.vue